import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import * as prototypeTypes from './types'; // you'll need to define these action types

export const actionCreators = {
  getPrototypeTimeEntries: (oid, startDate, endDate) => {
    return async (dispatch) => {
      try {
        dispatch({
          type: prototypeTypes.GET_PROTOTYPE_TIME_ENTRIES,
          oid,
          selectedDays: [startDate, endDate],
        });

        const headers = await getFetchHeaders();
        const url = `api/v2/TimeTracker/prototypeEntries?UserId=${oid}&StartDate=${startDate}&EndDate=${endDate}`;
        const response = await fetch(url, {
          method: 'GET',
          headers,
        });

        const data = await getFetchResponseData(response);

        dispatch({
          type: prototypeTypes.GET_PROTOTYPE_TIME_ENTRIES_SUCCESS,
          payload: data,
          selectedDays: [startDate, endDate],
        });
      } catch (error) {
        dispatch({
          type: prototypeTypes.GET_PROTOTYPE_TIME_ENTRIES_ERROR,
          error: error.message,
        });
        throw error;
      }
    };
  },
  upsertPrototypeTimeEntry: (
    userId,
    date,
    hours,
    projectNumber,
    partId,
    processId,
    requestId,
    requestNumber
  ) => {
    const tzOffset = new Date().getTimezoneOffset();

    return async (dispatch) => {
      try {
        const headers = await getFetchHeaders();
        const url = 'api/v2/TimeTracker/prototypeEntries/upsert';

        const res = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            PartId: partId,
            ProcessId: processId,
            requestId,
            requestNumber,
            projectNumber,
            date,
            userId,
            hours,
            timezone: tzOffset,
          }),
        });

        const data = await getFetchResponseData(res);

        dispatch({
          type: prototypeTypes.UPSERT_PROTOTYPE_TIME_ENTRY_SUCCESS,
          payload: data,
        });
      } catch (error) {
        dispatch({
          type: prototypeTypes.UPSERT_PROTOTYPE_TIME_ENTRY_ERROR,
          error: error.message,
        });
        throw error;
      }
    };
  },
  revertPrototypeTimeEntry: (procedureId, requestId, date, originalHours) => {
    return {
      type: prototypeTypes.REVERT_PROTOTYPE_TIME_ENTRY,
      payload: { procedureId, requestId, date, originalHours },
    };
  },

  deletePrototypeTimeEntry: (id) => {
    return async (dispatch) => {
      try {
        const headers = await getFetchHeaders();
        const url = `api/v2/TimeTracker/prototypeEntries/${id}`;

        await fetch(url, {
          method: 'DELETE',
          headers,
        });

        dispatch({
          type: prototypeTypes.DELETE_PROTOTYPE_TIME_ENTRY_SUCCESS,
          payload: id,
        });
      } catch (error) {
        dispatch({
          type: prototypeTypes.DELETE_PROTOTYPE_TIME_ENTRY_ERROR,
          error: error.message,
        });
        throw error;
      }
    };
  },
};
